module.exports = __webpack_public_path__ + "static/img/CRW_1469_1080p.138cf23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio3/CRW_1469_1080p.jpg
// module id = uWRN
// module chunks = 0